import { prefixClassName } from 'framework/components/ui/_conf';

export const clx = prefixClassName('summaryPanel');
